import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BtPayStoreModule } from '../btpay/btpay.store.module';
import { PaymentRulesStoreModule } from '../payment-rules/payment-rules.store.module';
import { SessionStoreModule } from '../session-store/session-store.module';
import { DisputeStoreModule } from '../dispute/dispute.store.module';
import { EffectsModule } from '@ngrx/effects';
import { PaymentInformationEffects } from '../shared-effects/payment-information.effects';
import { PaymentAccountsEffects } from '../shared-effects/payment-accounts.effects';
import { PadAgreementEffects } from '../shared-effects/pad-agreement.effects';
import { SharedSessionEffects } from '../shared-effects/shared-session.effects';
import { SharedPaymentRulesEffects } from '../shared-effects/shared-payment-rules.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    BtPayStoreModule,
    PaymentRulesStoreModule,
    SessionStoreModule,
    DisputeStoreModule,
    EffectsModule.forFeature([
      PaymentInformationEffects,
      PaymentAccountsEffects,
      PadAgreementEffects,
      SharedSessionEffects,
      SharedPaymentRulesEffects,
    ]),
  ],
  exports: [
    BtPayStoreModule,
    PaymentRulesStoreModule,
    SessionStoreModule,
    DisputeStoreModule,
  ],
})
export class SharedStoreModule {}
